import React, { useEffect, useRef } from "react";

// services
import { Mixpanel, MixpanelEvents } from "../services/Mixpanel";

// seo
import Seo from "../components/Seo";

// constants
import constant from "../constants";

// utils
import { saveUTM } from "../utils";

// image
import bannerImg from "../images/career/career-banner.png";

// custom hooks
import { useCommonPageTracking } from "../hooks/usePageTracking";

// components
import Banner from "../components/Banner";
import BuildCareer from "../components/Career/BuildCareer";
import OurCulture from "../components/Career/OurCulture";
import WhatCanExpect from "../components/Career/WhatCanExpect";
import TeamCanJoin from "../components/Career/TeamCanJoin";
import JoinBanner from "../components/Career/TeamCanJoin/JoinBanner";
import OpenRoles from "../components/Career/OpenRoles";
import CarouselV2 from "../components/Carousel/CarouselV2";

const CareerPage = props => {
  const formSectionRef = useRef(null);

  // Save utm to local storage
  useEffect(() => {
    if (props.location.search) {
      saveUTM(props.location.search);
    }
  }, [props.location.search]);

  // Use common page tracking hooks
  const { deviceType, operatingSystem } = useCommonPageTracking(
    "Careers Page",
    props.location.search
  );

  // Scroll to form section
  const scrollToForm = () => {
    if (formSectionRef.current) {
      formSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  // Mixpanel Events -> Cta Click events
  const handleMixpanelCTA = (ctaText, ctaLocation) => {
    Mixpanel.track(MixpanelEvents.contact_button_clicked, {
      page_name: "Careers Page",
      asset: "India Website",
      asset_name: "India Corporate Website",
      cta_text: ctaText,
      cta_location: ctaLocation,
      device_type: deviceType,
      operating_system: operatingSystem,
    });
  };

  return (
    <>
      <Seo
        title="Careers at Twin Health India | Join Our Mission"
        description="People are the heart of everything we do. Join a mission-driven team using AI and compassionate care to help millions lead healthier, happier lives."
      />
      <Banner
        pageName="For Careers"
        title="Careers at Twin Health"
        description="Join a mission-driven team transforming metabolic health through technology and compassionate care."
        ctaText="Apply Now"
        bannerImage={bannerImg}
        ctaLink=""
        onCtaClick={() => {
          handleMixpanelCTA(
            "Partner with Twin Health",
            "Carrers Page - Banner Section"
          );
          scrollToForm();
        }}
      />

      <BuildCareer
        onCtaClick={() => {
          handleMixpanelCTA(
            "View Open Roles",
            "Careers Page - Build Career Section"
          );
          scrollToForm();
        }}
      />

      <OurCulture />

      <CarouselV2
        items={constant.EMPLOYEE_STORIES_TESTIMONIALS}
        slidesToShow={2}
        slidesToShowMobile={1}
        gap={24}
        autoPlay={true}
        autoPlayInterval={4000}
        showArrows={true}
        showCounter={true}
        heading="Employee Stories"
        subHeading="Employee Stories"
      />

      <WhatCanExpect />

      <TeamCanJoin />

      <JoinBanner />

      <OpenRoles
        ref={formSectionRef}
        onCtaClick={() =>
          handleMixpanelCTA(
            "View Jobs on LinkedIn",
            "Careers Page - Open Roles Section"
          )
        }
      />
    </>
  );
};

export default CareerPage;
